import AlgoritmoBusqueda from "./Configuracion/algoritmoBusqueda";
import ContentConfiguracion from "./Configuracion/content";
import Impuestos from "./Configuracion/impuesto";
import ListaRecursosRestringidos from "./Configuracion/listaNegra";
import ConfigProfit from "./Configuracion/profit";
import ExigenciasSolicitud from "./Configuracion/requerimientosSolicitud";
import CotizacionSugerencias from "./Configuracion/sugerencias_cotizaciones";

export const ConfiguracionProfit = (props) => (
    <ContentConfiguracion component={<ConfigProfit />} {...props} />
);
export const ConfiguracionImpuesto = (props) => (
    <ContentConfiguracion component={<Impuestos />} {...props} />
);

export const ConfiguracionSugerencias = (props) => (
    <ContentConfiguracion component={<CotizacionSugerencias />} {...props} />
);

export const ConfiguracionAlgoritmoBusqueda = (props) => (
    <ContentConfiguracion component={<AlgoritmoBusqueda />} {...props} />
);

export const ConfiguracionListaRecursosRestringidos = (props) => (
    <ContentConfiguracion component={<ListaRecursosRestringidos />} {...props} />
);

export const ConfiguracionExigenciasSolicitud = (props) => (
    <ContentConfiguracion component={<ExigenciasSolicitud />} {...props} />
);